import useToastify from '../useToastify/useToastify';

const useHttpErrorsHandel = () => {
    const { showToastError } = useToastify();

    const httpErrorsHandel = (error: any) => {
        showToastError('Error on refetch data');

    }
    return { httpErrorsHandel };
}


export default useHttpErrorsHandel;